import { render } from "./UsersWork.vue?vue&type=template&id=4a45fd54"
import script from "./UsersWork.vue?vue&type=script&lang=js"
export * from "./UsersWork.vue?vue&type=script&lang=js"

import "./UsersWork.vue?vue&type=style&index=0&id=4a45fd54&lang=css"

import exportComponent from "C:\\PRO\\TimeSheet\\vue-cal-dev-ts-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__